import React, { useEffect, useState } from 'react';
import { Config } from '@leverege/plugin';
import { Content, Toast } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { GlobalState } from '@leverege/ui-redux';
import { connect } from 'react-redux';
import { LocationAlertsModel } from '@leverege/recovr-models';
import LocationAlertsEditor from '../editor/LocationAlertsEditor';
import { getVehicleUsageTypes } from '../../util/Model';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AlertScreen(props) {
  const {
    setTitle,
    setIcon,
    actions,
    locationAlerts,
    parentItem
  } = props;
  const [recipients, setRecipients] = useState(parentItem?.data?.data?.pendingSaleAlerts);
  useEffect(() => {
    if (setTitle) setTitle({
      data: 'Alert Rules'
    });
    if (setIcon) {
      setIcon({
        data: Config.get('AlertRules', 'screenIcon', 'https://recovr-ui-assets.storage.googleapis.com/icon-screen-alerts.png')
      });
    }
    setRecipients(parentItem?.data?.data?.pendingSaleAlerts);
  }, [setTitle, setIcon, parentItem]);
  const onChange = async ({
    value
  }) => {
    try {
      await GlobalState.dispatch(actions.update({
        header: [{
          path: 'metadata/locationAlerts',
          value
        }]
      }));
      Toast.success('Updated Alert Settings');
    } catch (err) {
      console.error(err);
      Toast.error(['Failed to Update Alert Settings', err.message]);
    }
  };
  const icon = Config.get('AlertRules', 'screenIcon', 'https://recovr-ui-assets.storage.googleapis.com/icon-screen-alerts.png');

  // Jank check for mobile for now
  const isMobile = setTitle != null;
  return /*#__PURE__*/_jsxs(Content, {
    children: [!isMobile && /*#__PURE__*/_jsx(Content.Header, {
      children: /*#__PURE__*/_jsx(TitleBar, {
        variant: "screenTitle",
        title: "Alert Rules",
        icon: icon
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      variant: "alertRulesContent|itemDashboardContent",
      children: /*#__PURE__*/_jsx(LocationAlertsEditor, {
        onChange: onChange,
        value: locationAlerts,
        actions: actions,
        recipients: recipients
      })
    })]
  });
}
const mapStateToProps = (state, props) => {
  const {
    parentItem
  } = props;
  const vehicleTypeValues = getVehicleUsageTypes(state).map(usageType => usageType.value);
  const EMPTY_MODEL = LocationAlertsModel({
    vehicleTypes: vehicleTypeValues
  }).create();
  return {
    locationAlerts: parentItem?.data?.metadata?.locationAlerts || EMPTY_MODEL
  };
};
export default connect(mapStateToProps)(AlertScreen);